<div class="back">

  <div id="wrapper">

    <div style="margin-bottom: 13px; " class="text-center"> <img src="../../assets/img/TataSteelpng.png" width="75%">
    </div>
    <div class="clr">
      <div class="ash text-center" size="3"> <b><span class="red">i</span><span class="blue">FIX</span> Service
          Management Foundation (SMF) Systems </b></div>
    </div>

    <br>

    <div class="form-group">
      <input type="text" class="form-control" [(ngModel)]="loginName" placeholder="Enter User Id">
    </div>

    <div class="form-group">
      <input type="password" class="form-control" [(ngModel)]="password" placeholder="Password">
    </div>

    <div class="text-center"><button class="btn btn-login" type="button" (click)="login()">Log
        In</button>&nbsp;</div>


  </div>
  <div id="godaddy-security-badge" class="godaddy-security-right"><img src="../../assets/img/ifix_logo_final-01.png"
      width="75%"></div>

  <div id="godaddy-security-badge" class="godaddy-security-left godaddy-security-light"></div>
</div>
<notifier-container></notifier-container>